module.exports = __webpack_public_path__ + "img/3.d652cb58.png";